import { checkFieldCondition } from './actionHelper'
import { isChecklistField } from './checklistHelper'
import type { DynamicField } from '../types'

export const isEmptyValue = (value: unknown) =>
  value === '' || value === null || typeof value === 'undefined' || (Array.isArray(value) && !value.length)

export const buildDefaults = (fields?: Array<DynamicField>) =>
  fields?.reduce<Record<string, unknown>>((acc, f) => {
    acc[f.param_key || ''] = isChecklistField(f) ? [] : (f.default ?? '')

    return acc
  }, {})

export const isFieldVisible = (field: DynamicField, values: Record<string, unknown>) => {
  const visibleIf = 'visible_if' in field ? field.visible_if : undefined

  return !visibleIf || checkFieldCondition(values, visibleIf)
}

export const isFieldRequired = (field: DynamicField, values: Record<string, unknown>) => {
  if (typeof field.required === 'boolean') return field.required

  const conditions = field.required ?? {}

  return Object.keys(conditions).length > 0 && checkFieldCondition(values, conditions)
}

export const buildSubmitPayload = (fields: Array<DynamicField> | undefined, values: Record<string, unknown>) => {
  const hiddenKeys = new Set((fields ?? []).filter((f) => !isFieldVisible(f, values)).map((f) => f.param_key || ''))

  return Object.entries(values).reduce<Record<string, unknown>>((acc, [key, value]) => {
    if (!hiddenKeys.has(key) && !isEmptyValue(value)) acc[key] = value

    return acc
  }, {})
}
